import React from "react";
import { UPLOAD_STATUS_LABELS } from "../../utils/datasetUploadApi";
import type { DatasetUploadStatus } from "../../utils/datasetUploadApi";
import { RUN_STATUS_LABELS } from "../../utils/datasetProcessingApi";
import type { ProcessingRunStatus } from "../../utils/datasetProcessingApi";

const DANGER = "border-eai-danger-border bg-eai-danger-surface text-eai-danger-text";
const SUCCESS = "border-eai-success-border bg-eai-success-surface-soft text-eai-success-text";
const NEUTRAL = "border-eai-border bg-eai-surface-sunken text-eai-ink-muted";

const UPLOAD_STATUS_CLASSES: Record<DatasetUploadStatus, string> = {
  LOADED: SUCCESS,
  REJECTED: DANGER,
  FAILED: DANGER,
  RECEIVED: NEUTRAL,
  REQUESTED: NEUTRAL,
  EXPIRED: "border-eai-border bg-eai-surface-sunken text-eai-ink-subtle",
};

const RUN_STATUS_CLASSES: Record<ProcessingRunStatus, string> = {
  SUCCEEDED: SUCCESS,
  FAILED: DANGER,
  RUNNING: NEUTRAL,
};

const PILL = "inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-eai-body-xs font-medium";

/** An upload's status as ingest reports it (EXPIRED is derived by the API for a link that lapsed unused). */
export const DatasetUploadStatusPill: React.FC<{ status: DatasetUploadStatus }> = ({ status }) => (
  <span className={`${PILL} ${UPLOAD_STATUS_CLASSES[status] || UPLOAD_STATUS_CLASSES.REQUESTED}`}>
    {UPLOAD_STATUS_LABELS[status] || status}
  </span>
);

/** A processing run's status, in the same colors as the upload's. */
export const ProcessingRunStatusPill: React.FC<{ status: ProcessingRunStatus }> = ({ status }) => (
  <span className={`${PILL} ${RUN_STATUS_CLASSES[status] || NEUTRAL}`}>{RUN_STATUS_LABELS[status] || status}</span>
);
